import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_reduced_height_size.js";
//#region src/kiosk_reduced_height_size_helper.ts
var kiosk_reduced_height_size_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(size) {
	switch (size) {
		case "small": return "Small (35% of screen height)";
		case "medium": return "Medium (50% of screen height)";
		case "large": return "Large (65% of screen height)";
	}
}
//#endregion
export { kiosk_reduced_height_size_helper_exports, name };

//# sourceMappingURL=kiosk_reduced_height_size_helper.js.map